import { ChatStatus } from 'interfaces/talkplus.interface'

export const STORAGE_KEY = {
    accessTokenKey: '_sq_atoken',
    refreshTokenKey: '_sq_rtoken',
    pwaStorageKey: 'pwa_storage',
    pushToken: 'push_token',
    firstAlarmConfirm: 'first_alarm_confirm',
    chatListScrollY: 'chat_list_scrollY',
    chatListFilterStatus: 'chat_list_filter_status',
    isTokenChecked: 'is_token_checked',
    searchWord: 'search_word',
    notificationAlertHidden: 'notification_alert_hidden',
    liveBroadcastSaved: 'live_broadcast_saved',
    filterTag: (userId: number) => `filter_tag_${userId}`,
    clickI: 'click_i',
}

export const STATUS_KOREAN: Record<ChatStatus, string> = {
    [ChatStatus.PENDING]: '대기',
    [ChatStatus.IN_PROGRESS]: '진행중',
    [ChatStatus.COMPLETED]: '완료',
}

export const MESSAGE_ALLOWED_DOMAINS = [
    'dasagayo.com',
    'pf.kakao.com',
    '3jy0w.channel.io',
    'docs.google.com',
    'www.miricanvas.com',
    'www.payapp.kr',
    'clickmate.kr',
    'smartstore.naver.com/bronz/products',
    'open.kakao.com/o/g3KiJ7Ag', // 프리오나 오픈채팅 링크
    'labang.me',
    'player.clickmate.kr',
    'srok.kr',
    'www.egtechcorp.com', // 쓰리백 페이지
]

export const CHAT_BLOCK_GUEST_IDS = [
    97400, // 장소영라라라이브
]
